<template>
  <list-table
    :url="url"
    title="لیست تسویه ها"
    :params="params"
    :fields="fields"
    :btns="btns"
  ></list-table>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TableShowData from "../../components/table";
import persianDate from "../../helpers/persianDate";
export default {
  name: "Identifier",
  data() {
    return {
      url: "~ref/api/v1/income/pending-settlements",
      detailUrl: "dfsdfsdf",
      fields: [
        {
          key: "user.name",
          label: "نام مشتری",
        },
        {
          key: "amount",
          label: "مبلغ درخواست",
          formatter: (value, key, item) => {
            return Number(-1 * value).toLocaleString();
          },
        },
        {
          key: "created_at",
          label: "تاریخ درخواست",
          formatter(value, key, item) {
            return persianDate.getDateByFormat(value);
          },
        },
        {
          key: "sattlement_iban",
          label: "شماره حساب درخواست",
        },

        {
          key: "setteled",
          label: "وضعیت",
          formatter(value, key, item) {
            var state = item.tracking_number;
            return state !== null ? "تسویه شده" : "تسویه نشده";
          },
          tdClass(value, key, item) {
            var state = item.tracking_number;
            return state !== null ? "text-success" : "text-danger";
          },
        },
        {
          key: "btns",
          label: "عملیات",
        },
      ],
      params: [
        
      ],
      btns: [
        {
          icon: "eye",
          title: "جزییات",
          handler: (t) => {
            this.$router.push("/identifier/details/" + t.id);
          },
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "درخواست های پرداخت پورسانت" },
    ]);
  },
  components: {
    "list-table": TableShowData,
  },
};
</script>